import './assets/styles/main.scss';

import { createApp } from 'vue';
import Matchmaker from '@/app/components/Matchmaker.vue';
import MatchmakerResults from '@/app/components/MatchmakerResults.vue';
import ChoiceCard from '@/app/components/ChoiceCard.vue';
import MatchmakerSingleChoiceStep from '@/app/components/MatchmakerSingleChoiceStep.vue';
import ProgressBar from '@/app/components/ProgressBar.vue';
import LegalPopin from '@/app/components/LegalPopin.vue';

createApp({
    name: 'App',
    components: {
        Matchmaker,
        MatchmakerResults,
        ChoiceCard,
        MatchmakerSingleChoiceStep,
        ProgressBar,
        LegalPopin,
    },
}).mount('#app');
